//

namespace Analytics
{

    export enum Type
    {
        PAGE        = "pageview",
        EVENT       = "event",
        TIMING      = "timing",
        EXCEPTION   = "exception",
        VIEW        = "screenview",
    }
}


export default Analytics;
// eof